import React, { useEffect } from "react";
import { Button } from "react-bootstrap";
import * as uuid from "uuid";
import isEmpty from "lodash/isEmpty";
import OrganizationDetailsForm from "./OrganizationDetailsForm";
import { organizationObject } from "../../constants/candidateDataObjects";
import "../../styles/styles.css";

export const OrganizationInfo = ({
  candidateId,
  organizationDetails,
  updateCandidateOrganizationDetails,
  addCandidateOrganizationDetails,
  deleteCandidateOrganizationDetails
}) => {
  const defaultOrganizationDetails = organizationObject();

  useEffect(() => {
    if (!organizationDetails.length)
      addCandidateOrganizationDetails({
        ...defaultOrganizationDetails,
        id: `temp_${uuid.v4()}`,
        candidateId
      });
  }, []);
  return (
    <>
      <p className="text-center text-danger pt-4">
        If you don't have work experience, Please click NEXT to continue.
      </p>
      <div className="container w-100 h-100 mx-auto pt-3 mb-5 org-details">
        {organizationDetails.map((organization, index) => (
          <OrganizationDetailsForm
            organizationDetails={organization}
            index={index}
            updateCandidateOrganizationDetails={
              updateCandidateOrganizationDetails
            }
            addCandidateOrganizationDetails={addCandidateOrganizationDetails}
            deleteCandidateOrganizationDetails={
              deleteCandidateOrganizationDetails
            }
          />
        ))}
        <Button
          variant="success"
          className="float-right mt-3"
          onClick={() => {
            addCandidateOrganizationDetails({
              ...defaultOrganizationDetails,
              id: `temp_${uuid.v4()}`,
              candidateId
            });
          }}
        >
          ADD ANOTHER ORGANIZATION
        </Button>
      </div>
    </>
  );
};
export default OrganizationInfo;
